import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class NotificationService {

  constructor( private readonly toastr: ToastrService ) { }

  public showSuccess( message: string, title = '', configOptions = {} ): void {
    this.toastr.success( message, title, configOptions );
  }
  public showError( message: string, title = '', configOptions = {} ): void {
    this.toastr.error( message, title, configOptions );
  }

  public showInfo( message: string, title = '', configOptions = {} ): void {
    this.toastr.info( message, title, configOptions );
  }

  public showWarning( message: string, title = '', configOptions = {} ): void {
    this.toastr.warning( message, title, configOptions );
  }
}
